import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import FIcon from "@components/FIcon";
import { NavigationLink, NavigationSection } from "@components/FSidebar";
import { useBreakpoint } from "@hooks/tailwind";

interface Props {
  isOpen: boolean;
  onClose: () => void;
  sections: NavigationSection[];
}

const MobileSidebar = ({ isOpen, onClose, sections }: Props) => {
  const location = useLocation();
  const currentPath = location.pathname;

  const isMobile = !useBreakpoint("c-lg");

  // Close sidebar when clicking outside or pressing escape
  useEffect(() => {
    const handleEscape = (e: KeyboardEvent) => {
      if (e.key === "Escape" && isOpen) {
        onClose();
      }
    };

    document.addEventListener("keydown", handleEscape);
    return () => {
      document.removeEventListener("keydown", handleEscape);
    };
  }, [isOpen, onClose]);

  return (
    <>
      {/* Overlay - Cover the entire screen including navbar */}
      {isOpen && (
        <div
          className="fixed inset-0 bg-black bg-opacity-50 z-[9999]"
          onClick={onClose}
        />
      )}

      {/* Sidebar */}
      <div
        className={`fixed top-0 right-0 h-full w-[85%] max-w-[280px] bg-gradient-to-b from-highlight_red to-light_red z-[9999] transform transition-transform duration-300 ease-in-out overflow-y-auto shadow-lg ${
          isOpen ? "translate-x-0" : "translate-x-full"
        }`}
      >
        <div className="py-2 px-4 border-b border-light_border flex justify-between items-center">
          <h2 className="text-lg leading-none font-medium text-black">Menu</h2>
          <button
            onClick={onClose}
            className="flex items-center justify-center h-[32px] w-[32px] rounded-lg hover:bg-white transition-colors"
            aria-label="Close menu"
          >
            <FIcon icon="exit" size={18} color="#000" />
          </button>
        </div>

        <div className="py-4">
          {sections.map((section, sectionIndex) => (
            <div
              key={sectionIndex}
              className={`${section.fixedBottom ? "mt-auto" : ""}`}
            >
              {section.title && !isMobile && (
                <div className="px-4 py-2 text-sm text-black uppercase">
                  {section.title}
                </div>
              )}
              <div className="text-sm px-4">
                {section.items.map((item, itemIndex) => (
                  <NavigationLink
                    key={itemIndex}
                    item={item}
                    currentPath={currentPath}
                    isMobile={true}
                    onClose={onClose}
                  />
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </>
  );
};

export default MobileSidebar;
